import { Container, Row, Col } from "react-bootstrap";
import { useEffect, useState } from "react";
import Link from "next/link";
import Swiper from "react-id-swiper";
import { isMobile } from "react-device-detect";
import Skeleton from "react-loading-skeleton";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { connect } from "react-redux";
import {
  fetchRecommendedByBrandWorkshop,
  fetchRecommendedOBAssuredWorkshop,
  fetchRecommendedWorkshop,
} from "../../redux/actions/apiActions";
import { toast } from "react-hot-toast";
import { setCarPopup, setLoader } from "../../redux/actions/globalAction";
import { FaCar } from "react-icons/fa";
import Image from "next/image";
import ConfirmCartChange from "../common/ConfirmCartChange";
import { gtmWorkshopCollection } from "../../lib/google-tag-manager";
import LazyLoad from 'react-lazyload';

const Recommends = ({
  apiData,
  cart,
  fetchRecommendedByBrandWorkshop,
  fetchRecommendedOBAssuredWorkshop,
  fetchRecommendedWorkshop,
  profile,
  globalData,
  setCarPopup,
  setLoader,
}) => {
  const [tab, setTab] = useState("nearest");
  const [dataRecommended, setDataRecommended] = useState(null);
  const [dataOBAssured, setDataOBAssured] = useState(null);
  const [dataByBrand, setDataByBrand] = useState(null);

  const carNameParam = 'car';

  useEffect(() => {
    // Test Area profile.location to globalData.locationData
    if (globalData.locationData.lat != 0) {
      fetchRecommendedWorkshop(
        globalData.locationData.lat,
        globalData.locationData.lng,
        10
      );
    }
  }, [globalData.locationData]);

  useEffect(() => {
    if (globalData.locationData?.lat != 0 && globalData.carData?.brandId) {
      fetchRecommendedByBrandWorkshop(
        globalData.locationData?.lat,
        globalData.locationData?.lng,
        globalData.carData?.brandId
      );
    }
  }, [globalData.locationData, globalData.carData]);

  useEffect(() => {
    setDataRecommended(apiData.recommendedWorkshops);
    setDataOBAssured(apiData.recommendedOBAssuredWorkshops);
    setDataByBrand(apiData.recommendedByBrandWorkshops);
  }, [
    apiData.recommendedWorkshops,
    apiData.recommendedOBAssuredWorkshops,
    apiData.recommendedByBrandWorkshops,
  ]);

  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    lazyload: true,
    // slidesToShow: Math.min(images.length, 3),
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const handleOffers = () => {
    setTab("obAssured");
    if (globalData.locationData.lat != 0) {
      fetchRecommendedOBAssuredWorkshop(
        globalData.locationData.lat,
        globalData.locationData.lng
      );
    }
  }

  const handleExperts = () => {
    setTab("byBrand");
    if (globalData.locationData.lat != 0) {
      profile.selectedCar?.brandId &&
        fetchRecommendedByBrandWorkshop(
          globalData.locationData.lat,
          globalData.locationData.lng,
          profile.selectedCar?.brandId
        );
    }
  }

  return (
    <div
      style={{ paddingLeft: "30px", paddingRight: "30px" }}
      className="mb-sm-5 mb-4"
      id="recommend"
    >
      <Container fluid>
        <Row className="justify-content-center">
          <Col lg={12}>
            <div className="text-center title-anim">
              <div className="header-all">Workshop Collections</div>
            </div>
            <p className="subHead-all text-center">
              We have curated a list of our partners servicing all your needs
            </p>
          </Col>
        </Row>
        <Row>
          <Col
            sm={12}
            style={{ zIndex: 9 }}
            className="d-flex align-items-center justify-content-end"
          >
            <div
              className="d-flex align-items-center justify-content-evenly"
              style={{ paddingBottom: "10px", paddingTop: "10px" }}
            >
              <div className="text-align-center filter-text ">Filter by:</div>
              <div
                className={`${tab == "nearest" ? "tag-rec-selected" : "tag-rec"
                  }`}
                onClick={() => {
                  setTab("nearest");
                }}
              >
                Nearest
              </div>
              <div
                className={`${tab == "obAssured" ? "tag-rec-selected" : "tag-rec"
                  }`}
                onClick={() => handleOffers()}
              >
                Offers
              </div>
              <div
                className={`${tab == "byBrand" ? "tag-rec-selected" : "tag-rec"
                  }`}
                onClick={() => {
                  if (globalData.carData?.brandId) {
                    handleExperts();
                  } else {
                    toast("Select Car to View Experts!", {
                      icon: <FaCar />,
                      // position: "bottom-left",
                      style: {
                        // border: "1px solid #0451be",
                        // padding: "16px",
                        color: "#F58B1F",
                        fontWeight: "bold",
                        // backgroundColor: '#0451be'
                      },
                    });
                    setCarPopup("brand");
                  }
                }}
              >
                {globalData.carData?.brand} Experts
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} style={{ marginTop: "-45px" }}>
            {tab == "nearest" && (
              <>
                {dataRecommended ? (
                  <Slider {...settings} slidesToShow={3}>
                    {dataRecommended?.map((e, index) => {
                      return (
                        <LazyLoad key={index}>
                          <div className="d-flex justify-content-center align-items-center flex-column mt-5 item-head">
                            {/* {cart.workshop ? (
                            <a
                              className="w-100"
                              onClick={() => {
                                setShowWarning(true);
                                setRedirectURL(
                                  `/services/${
                                    globalData.locationData?.data
                                      ?.EmirateAreaSlug || "dubai"
                                  }/oil-change`
                                );
                                setRedirectWorkshopURL(
                                  `/services/${
                                    globalData.locationData?.data
                                      ?.EmirateAreaSlug || "dubai"
                                  }/oil-change/null/${e.Slug}`
                                );
                                // setLoader(true);
                              }}
                            >
                              <div className="recommend-card">
                                <div className="recommend-container">
                                  <div className="recommend-image-container">
                                    <div
                                      style={{
                                        width: "100%",
                                        position: "relative",
                                        borderRadius: "15px",
                                        overflow: "hidden",
                                      }}
                                      className="img"
                                    >
                                      <Image
                                        src={
                                          e.CoverImageUrl ||
                                          "/assets/workshop-default.webp"
                                        }
                                        alt="Recommended Workshops"
                                        layout="fill"
                                        objectFit="cover"
                                      />
                                    </div>
                                    <div className="recommend-user">
                                      <img
                                        src="/assets/images/workshop_location.svg"
                                        width={13}
                                        style={{ margin: "4px" }}
                                      />
                                      <div
                                        className="user-text"
                                        style={{
                                          color: "#0451be",
                                          margin: "4px",
                                        }}
                                      >
                                        {parseFloat(e.Distance).toFixed(2)} KM
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      fontWeight: "bolder",
                                      fontSize: 20,
                                      marginTop: "10px",
                                    }}
                                  >
                                    {e.Name}
                                  </div>
                                  <div
                                    style={{
                                      color: "#0451be",
                                      textAlign: "left",
                                    }}
                                  >
                                    {e.AreaName}
                                  </div>
                                </div>
                              </div>
                            </a>
                          ) : ( */}
                            <Link
                              href={`/services/${globalData.locationData?.data
                                ?.EmirateAreaSlug || "dubai"
                                }/oil-change/${carNameParam}/${e.Slug}`}
                            >
                              <a
                                className="w-100"
                                onClick={() => {
                                  sessionStorage.setItem("isWorkshopCollection", true)
                                  localStorage.setItem("selected-service-title", e.Name)
                                  setLoader(true)
                                  gtmWorkshopCollection(e.Name)
                                }}
                              >
                                <div className="recommend-card">
                                  <div className="recommend-container">
                                    <div className="recommend-image-container">
                                      <div
                                        style={{
                                          width: "100%",
                                          position: "relative",
                                          borderRadius: "15px",
                                          overflow: "hidden",
                                        }}
                                        className="img"
                                      >
                                        <Image
                                          src={
                                            e.CoverImageUrl ||
                                            "/assets/workshop-default.webp"
                                          }
                                          alt="Recommended Workshops"
                                          layout="fill"
                                          objectFit="cover"
                                        />
                                      </div>
                                      <div className="recommend-user">
                                        <img
                                          src="/assets/images/workshop_location.svg"
                                          alt="workshop_location"
                                          width={13}
                                          style={{ margin: "4px" }}
                                        />
                                        <div
                                          className="user-text"
                                          style={{
                                            color: "#0451be",
                                            margin: "4px",
                                          }}
                                        >
                                          {parseFloat(e.Distance).toFixed(2)} KM
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        fontWeight: "bolder",
                                        fontSize: 20,
                                        marginTop: "10px",
                                      }}
                                    >
                                      {e.Name}
                                    </div>
                                    <div
                                      style={{
                                        color: "#0451be",
                                        textAlign: "left",
                                      }}
                                    >
                                      {e.AreaName}
                                    </div>
                                  </div>
                                </div>
                              </a>
                            </Link>
                            {/* )} */}
                          </div >
                        </LazyLoad >
                      );
                    })}
                  </Slider >
                ) : (
                  <Row className="mt-5">
                    {/* Test Area */}
                    <Col sm={4}>
                      {/* <Image
                        src={LoadingImage}
                        alt="Loader"
                        height={300}
                        width="100%"
                      /> */}
                      <Skeleton style={{ width: "100%", height: 300 }} />
                    </Col>
                    <Col sm={4}>
                      {/* <Image
                        src={LoadingImage}
                        alt="Loader"
                        height={300}
                        width="100%"
                      /> */}
                      <Skeleton style={{ width: "100%", height: 300 }} />
                    </Col>
                    <Col sm={4}>
                      {/* <Image
                        src={LoadingImage}
                        alt="Loader"
                        height={300}
                        width="100%"
                      /> */}
                      <Skeleton style={{ width: "100%", height: 300 }} />
                    </Col>
                    {/* <Col sm={4}>
                      <Skeleton style={{ width: "100%", height: 300 }} />
                    </Col>
                    <Col sm={4}>
                      <Skeleton style={{ width: "100%", height: 300 }} />
                    </Col>
                    <Col sm={4}>
                      <Skeleton style={{ width: "100%", height: 300 }} />
                    </Col> */}
                  </Row>
                )}
                {
                  dataRecommended?.length == 0 && (
                    <Row className="mt-5 justify-content-center align-items-center bg-grey-official p-5">
                      <img src="/assets/work-in-progress.webp" alt="progress" height="250px" />
                      <div className="ml-md-5">
                        <h1>Stay Tuned!</h1>
                        <p className="text-dark">
                          We are working on to bring you a great experience.
                        </p>
                      </div>
                    </Row>
                  )
                }
              </>
            )}
            {
              tab == "obAssured" && (
                <>
                  {dataOBAssured ? (
                    dataOBAssured?.length < 3 ?
                      <Row className="justify-content-center">
                        {dataOBAssured?.map((e, index) => {
                          return (
                            <Col className="p-0" md={4} key={index}>
                              <div
                                className="-flex justify-content-center align-items-center flex-column mt-5 item-head"
                              >
                                <Link
                                  href={`/services/${globalData.locationData?.data
                                    ?.EmirateAreaSlug || "dubai"
                                    }/oil-change/${carNameParam}/${e.Slug}`}
                                >
                                  <a
                                    className="w-100"
                                    onClick={() => setLoader(true)}
                                  >
                                    <div className="recommend-card">
                                      <div className="recommend-container">
                                        <div className="recommend-image-container">
                                          <div
                                            style={{
                                              width: "100%",
                                              position: "relative",
                                              borderRadius: "15px",
                                              overflow: "hidden",
                                            }}
                                            className="img"
                                          >
                                            <Image
                                              src={
                                                e.CoverImageUrl ||
                                                "/assets/workshop-default.webp"
                                              }
                                              alt="Recommended Workshops"
                                              layout="fill"
                                              objectFit="cover"
                                            />
                                          </div>
                                          <div
                                            className="recommend-user"
                                            style={{ background: "#fff" }}
                                          >
                                            <img
                                              src="/assets/images/discount.svg"
                                              width={25}
                                              alt="discount"
                                            />
                                            <div
                                              className="user-text"
                                              style={{
                                                color: "#F58B1F",
                                                margin: "4px",
                                              }}
                                            >
                                              {"Offer Available"}
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          style={{
                                            fontWeight: "bolder",
                                            fontSize: 20,
                                            marginTop: "10px",
                                          }}
                                        >
                                          {e.Name}
                                        </div>
                                        <div
                                          style={{
                                            color: "#0451be",
                                            textAlign: "left",
                                          }}
                                        >
                                          {e.AreaName}
                                        </div>
                                      </div>
                                    </div>
                                  </a>
                                </Link>
                              </div>
                            </Col>
                          );
                        })} </Row>
                      : <Slider {...settings} slidesToShow={3}>
                        {dataOBAssured?.map((e, index) => {
                          return (
                            <div
                              className="d-flex justify-content-center align-items-center flex-column mt-5 item-head"
                            >
                              {/* {cart.workshop ? (
                            <a
                              className="w-100"
                              onClick={() => {
                                setShowWarning(true);
                                setRedirectURL(
                                  `/services/${
                                    globalData.locationData?.data
                                      ?.EmirateAreaSlug || "dubai"
                                  }/oil-change`
                                );
                                setRedirectWorkshopURL(
                                  `/services/${
                                    globalData.locationData?.data
                                      ?.EmirateAreaSlug || "dubai"
                                  }/oil-change/null/${e.Slug}`
                                );
                                setLoader(true);
                              }}
                            >
                              <div className="recommend-card">
                                <div className="recommend-container">
                                  <div className="recommend-image-container">
                                    <div
                                      style={{
                                        width: "100%",
                                        position: "relative",
                                        borderRadius: "15px",
                                        overflow: "hidden",
                                      }}
                                      className="img"
                                    >
                                      <Image
                                        src={
                                          e.CoverImageUrl ||
                                          "/assets/workshop-default.webp"
                                        }
                                        alt="Recommended Workshops"
                                        layout="fill"
                                        objectFit="cover"
                                      />
                                    </div>
                                   
                                    <div
                                      className="recommend-user"
                                      style={{ background: "#fff" }}
                                    >
                                      <img
                                        src="/assets/images/discount.svg"
                                        width={25}
                                      />
                                      <div
                                        className="user-text"
                                        style={{
                                          color: "#F58B1F",
                                          margin: "4px",
                                        }}
                                      >
                                        {"Offer Available"}
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      fontWeight: "bolder",
                                      fontSize: 20,
                                      marginTop: "10px",
                                    }}
                                  >
                                    {e.Name}
                                  </div>
                                  <div
                                    style={{
                                      color: "#0451be",
                                      textAlign: "left",
                                    }}
                                  >
                                    {e.AreaName}
                                  </div>
                                </div>
                              </div>
                            </a>
                          ) : ( */}
                              <Link
                                href={`/services/${globalData.locationData?.data
                                  ?.EmirateAreaSlug || "dubai"
                                  }/oil-change/${carNameParam}/${e.Slug}`}
                              >
                                <a
                                  className="w-100"
                                  onClick={() => setLoader(true)}
                                >
                                  <div className="recommend-card">
                                    <div className="recommend-container">
                                      <div className="recommend-image-container">
                                        <div
                                          style={{
                                            width: "100%",
                                            position: "relative",
                                            borderRadius: "15px",
                                            overflow: "hidden",
                                          }}
                                          className="img"
                                        >
                                          <Image
                                            src={
                                              e.CoverImageUrl ||
                                              "/assets/workshop-default.webp"
                                            }
                                            alt="Recommended Workshops"
                                            layout="fill"
                                            objectFit="cover"
                                          />
                                        </div>
                                        {/* <img
                                      src={`${e.CoverImageUrl}`}
                                      width={"100%"}
                                      style={{ borderRadius: "15px" }}
                                    /> */}
                                        {/* <div className="recommend-discount">
                                      <img
                                        src="/assets/images/discount.svg"
                                        width={25}
                                      />
                                      <div
                                        className="discount-text"
                                        style={{
                                          color: "#F58B1F",
                                          margin: "4px",
                                        }}
                                      >
                                        5% discount
                                      </div>
                                    </div> */}
                                        <div
                                          className="recommend-user"
                                          style={{ background: "#fff" }}
                                        >
                                          <img
                                            src="/assets/images/discount.svg"
                                            width={25}
                                            alt="discount"
                                          />
                                          <div
                                            className="user-text"
                                            style={{
                                              color: "#F58B1F",
                                              margin: "4px",
                                            }}
                                          >
                                            {"Offer Available"}
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        style={{
                                          fontWeight: "bolder",
                                          fontSize: 20,
                                          marginTop: "10px",
                                        }}
                                      >
                                        {e.Name}
                                      </div>
                                      <div
                                        style={{
                                          color: "#0451be",
                                          textAlign: "left",
                                        }}
                                      >
                                        {e.AreaName}
                                      </div>
                                    </div>
                                  </div>
                                </a>
                              </Link>
                              {/* )} */}
                            </div>
                          );
                        })}
                      </Slider>
                  ) : (
                    <Row className="mt-5">
                      <Col sm={4}>
                        <Skeleton style={{ width: "100%", height: 300 }} />
                      </Col>
                      <Col sm={4}>
                        <Skeleton style={{ width: "100%", height: 300 }} />
                      </Col>
                      <Col sm={4}>
                        <Skeleton style={{ width: "100%", height: 300 }} />
                      </Col>
                    </Row>
                  )}
                  {dataOBAssured?.length == 0 && (
                    <Row className="mt-5 justify-content-center align-items-center bg-grey-official p-5">
                      <img src="/assets/work-in-progress.webp" alt="progress" height="250px" />
                      <div className="ml-md-5">
                        <h1>Stay Tuned!</h1>
                        <p className="text-dark">
                          We are working on to bring you a great experience.
                        </p>
                      </div>
                    </Row>
                  )}
                </>
              )
            }
            {
              tab == "byBrand" && (
                <>
                  {dataByBrand ? (
                    <Slider {...settings} slidesToShow={3}>
                      {dataByBrand.map((e, index) => {
                        return (
                          <div
                            className="d-flex justify-content-center align-items-center flex-column mt-5 item-head"
                          // onClick={() => alert("hello")}
                          >
                            {/* {cart.workshop ? (
                            <a
                              className="w-100"
                              onClick={() => {
                                setShowWarning(true);
                                setRedirectURL(
                                  `/services/${
                                    globalData.locationData?.data
                                      ?.EmirateAreaSlug || "dubai"
                                  }/oil-change`
                                );
                                setRedirectWorkshopURL(
                                  `/services/${
                                    globalData.locationData?.data
                                      ?.EmirateAreaSlug || "dubai"
                                  }/oil-change/null/${e.Slug}`
                                );
                                setLoader(true)}}
                            >
                              <div className="recommend-card">
                                <div className="recommend-container">
                                  <div className="recommend-image-container">
                                    <div
                                      style={{
                                        width: "100%",
                                        position: "relative",
                                        borderRadius: "15px",
                                        overflow: "hidden",
                                      }}
                                      className="img"
                                    >
                                      <Image
                                        src={
                                          e.CoverImageUrl ||
                                          "/assets/workshop-default.webp"
                                        }
                                        alt="Recommended Workshops"
                                        layout="fill"
                                        objectFit="cover"
                                      />
                                    </div>
                                    <div className="recommend-user">
                                      <img
                                        src={
                                          globalData.carData?.brandUrl ||
                                          "/assets/images/brands/bmw.webp"
                                        }
                                        width={23}
                                        style={{ margin: "1px" }}
                                      />
                                      <div
                                        className="user-text"
                                        style={{
                                          color: "#0451be",
                                          margin: "4px",
                                        }}
                                      >
                                        {globalData.carData?.brand}
                                      </div>
                                    </div>
                                    <div
                                      className="recommend-user right"
                                      style={{ background: "#0451be" }}
                                    >
                                      <img
                                        src="/assets/workshop/assure.svg"
                                        width={13}
                                        style={{ margin: "4px" }}
                                      />
                                      <div
                                        className="user-text"
                                        style={{ color: "#fff", margin: "4px" }}
                                      >
                                        {"OB ASSURE"}
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      fontWeight: "bolder",
                                      fontSize: 20,
                                      marginTop: "10px",
                                    }}
                                  >
                                    {e.Name}
                                  </div>
                                  <div
                                    style={{
                                      color: "#0451be",
                                      textAlign: "left",
                                    }}
                                  >
                                    {e.AreaName}
                                  </div>
                                </div>
                              </div>
                            </a>
                          ) : ( */}
                            <Link
                              href={`/services/${globalData.locationData?.data
                                ?.EmirateAreaSlug || "dubai"
                                }/oil-change/${carNameParam}/${e.Slug}`}
                            >
                              <a
                                className="w-100"
                                onClick={() => setLoader(true)}
                              >
                                <div className="recommend-card">
                                  <div className="recommend-container">
                                    <div className="recommend-image-container">
                                      <div
                                        style={{
                                          width: "100%",
                                          position: "relative",
                                          borderRadius: "15px",
                                          overflow: "hidden",
                                        }}
                                        className="img"
                                      >
                                        <Image
                                          src={
                                            e.CoverImageUrl ||
                                            "/assets/workshop-default.webp"
                                          }
                                          alt="Recommended Workshops"
                                          layout="fill"
                                          objectFit="cover"
                                        />
                                      </div>
                                      {/* <img
                                      src={`${e.CoverImageUrl}`}
                                      width={"100%"}
                                      style={{ borderRadius: "15px" }}
                                    /> */}
                                      {/* <div className="recommend-discount">
                                      <img
                                        src="/assets/images/discount.svg"
                                        width={25}
                                      />
                                      <div
                                        className="discount-text"
                                        style={{
                                          color: "#F58B1F",
                                          margin: "4px",
                                        }}
                                      >
                                        5% discount
                                      </div>
                                    </div> */}
                                      <div className="recommend-user">
                                        <img
                                          src={
                                            globalData.carData?.brandUrl ||
                                            "/assets/images/brands/bmw.webp"
                                          }
                                          alt="brand"
                                          width={23}
                                          style={{ margin: "1px" }}
                                        />
                                        <div
                                          className="user-text"
                                          style={{
                                            color: "#0451be",
                                            margin: "4px",
                                          }}
                                        >
                                          {globalData.carData?.brand}
                                        </div>
                                      </div>
                                      <div
                                        className="recommend-user right"
                                        style={{ background: "#0451be" }}
                                      >
                                        <img
                                          src="/assets/workshop/assure.svg"
                                          alt="assure"
                                          width={13}
                                          style={{ margin: "4px" }}
                                        />
                                        <div
                                          className="user-text"
                                          style={{
                                            color: "#fff",
                                            margin: "4px",
                                          }}
                                        >
                                          {"OB ASSURE"}
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        fontWeight: "bolder",
                                        fontSize: 20,
                                        marginTop: "10px",
                                      }}
                                    >
                                      {e.Name}
                                    </div>
                                    <div
                                      style={{
                                        color: "#0451be",
                                        textAlign: "left",
                                      }}
                                    >
                                      {e.AreaName}
                                    </div>
                                  </div>
                                </div>
                              </a>
                            </Link>
                            {/* )} */}
                          </div>
                        );
                      })}
                    </Slider>
                  ) : (
                    <Row className="mt-5">
                      <Col sm={4}>
                        <Skeleton style={{ width: "100%", height: 300 }} />
                      </Col>
                      <Col sm={4}>
                        <Skeleton style={{ width: "100%", height: 300 }} />
                      </Col>
                      <Col sm={4}>
                        <Skeleton style={{ width: "100%", height: 300 }} />
                      </Col>
                    </Row>
                  )}
                  {dataByBrand?.length == 0 && (
                    <Row className="mt-5 justify-content-center align-items-center bg-grey-official p-5">
                      <img src="/assets/work-in-progress.webp" height="250px" alt="progress" />
                      <div className="ml-md-5">
                        <h1>Stay Tuned!</h1>
                        <p className="text-dark">
                          We are working on to bring you a great experience.
                        </p>
                      </div>
                    </Row>
                  )}
                </>
              )
            }
          </Col >
          {/* : isMobile ?
              <Col lg={12} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <Skeleton style={{ width: '100%', height: '240px' }} />
                  <Skeleton style={{ width: '100%' }} />
                  <Skeleton style={{ width: '100%' }} />
                </div>
              </Col>
              :
              <Col lg={12} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
              
                <div>
                  <Skeleton style={{ width: '100%', height: '240px' }} />
                  <Skeleton style={{ width: '100%' }} />
                  <Skeleton style={{ width: '100%' }} />
                </div>
              </Col>} */}
        </Row >
        {/* <ConfirmCartChange
          show={showWarning}
          onHide={() => setShowWarning(false)}
          redirectURL={redirectURL}
          redirectWorkshopURL={redirectWorkshopURL}
        /> */}
      </Container >
    </div >
  );
};

const mapStateToProps = (state) => {
  return {
    apiData: state.apiData,
    globalData: state.globalData,
    profile: state.profile,
    cart: state.cart,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    fetchRecommendedWorkshop: (lat, lang, size) => {
      dispatch(fetchRecommendedWorkshop(lat, lang, size));
    },
    fetchRecommendedOBAssuredWorkshop: (lat, lang) => {
      dispatch(fetchRecommendedOBAssuredWorkshop(lat, lang));
    },
    fetchRecommendedByBrandWorkshop: (lat, lang, carId) => {
      dispatch(fetchRecommendedByBrandWorkshop(lat, lang, carId));
    },
    setCarPopup: (flag) => {
      dispatch(setCarPopup(flag));
    },
    setLoader: (flag) => {
      dispatch(setLoader(flag));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Recommends);



